import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=8ed1ab86&scoped=true&"
import script from "./newsList.vue?vue&type=script&lang=js&"
export * from "./newsList.vue?vue&type=script&lang=js&"
import style0 from "./newsList.vue?vue&type=style&index=0&id=8ed1ab86&lang=scss&scoped=true&"
import style1 from "./newsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed1ab86",
  null
  
)

export default component.exports